import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { getFullName } from '../../../../../../helpers/auth';
import { propStr, propShape } from '../../../../../../helpers/custom-prop-types';
import PersonIcon from '../../../../../Icon/Svg/PersonIcon';
const SlideSearchHeaderSideMenuProfile = (props) => {
    const { className, profile } = props;
    return (_jsxs(Link, Object.assign({ className: clsx('slide_search_header_side_menu_profile', className), to: '/mypage' }, { children: [_jsx("div", Object.assign({ className: 'profile_left' }, { children: _jsx("div", Object.assign({ className: 'left_inner' }, { children: _jsx(PersonIcon, { className: 'left_svg' }) })) })), _jsxs("div", Object.assign({ className: 'profile_right' }, { children: [_jsx("p", Object.assign({ className: 'right_name' }, { children: getFullName(profile) })), _jsx("p", Object.assign({ className: 'right_organization' }, { children: profile.organization && profile.organization.name }))] }))] })));
};
SlideSearchHeaderSideMenuProfile.propTypes = {
    className: propStr(),
    profile: propShape().isRequired,
};
SlideSearchHeaderSideMenuProfile.defaultProps = {
    className: '',
};
export default SlideSearchHeaderSideMenuProfile;
